<p-confirmDialog key="manualconfirm" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="manualresult" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Instructions-->
<div class="ItemBorder">
	<h4 style="text-align: center">Instructions:</h4>

	<div class="AlignCenter">
		<ul>
			<li>
				<p class="InstructionText">This page lets you create and manage "visitees" or people that can be visited in the CAASS Visitors app</p>
			</li>
			<li>
				<p class="InstructionText">
					When a visitor says they are going to visit a visitee, the visitee will receive an email notification saying who is visiting and where they
					checked in.
				</p>
			</li>
			<li>
				<p class="InstructionText">Search for Staff to update their Visitee status</p>
			</li>
			<li>
				<p class="InstructionText">Confirm that the staff's email addresses are correct and that their visitee status is turned on or off</p>
			</li>
			<li>
				<p class="InstructionText">
					Press update and the data will show up in the CAASS Visitors App on the Visitor Photo page when a visitor signs in to a facility the staff
					member has access to.
				</p>
			</li>
			<li>
				<p class="InstructionText">Note: Reset clears all of the changes that you made to the staff's emails (They default to what is in CAASS).</p>
			</li>
		</ul>
	</div>
</div>

<!--Search Options-->
<div class="SearchOptionBorder TopMargin">
	<h4>Search Options:</h4>

	<div class="SearchOptionDiv">
		<label>School:</label>
		<caass-schoolselector [Disabled]="IsLoading() == true" [ShowAll]="true" [ShowAllID]="SchoolSelectShowAllID" [ShowAllText]="SchoolSelectShowAllText">
		</caass-schoolselector>

		<label>Staff Type:</label>
		<p-dropdown
			[disabled]="IsLoading() == true"
			[options]="lstPersonType"
			[(ngModel)]="SelectedPersonType"
			optionLabel="PersonTypeDesc"
			[filter]="true"
			filterBy="PersonTypeDesc"
			[showClear]="false"
			placeholder="Select a Staff Type"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="SelectedPersonType">
					<div class="form-control NoBorder" style="text-align: left">
						{{ SelectedPersonType.PersonTypeDesc }}
					</div>
				</div>
			</ng-template>
			<ng-template let-PersonTypeItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left">
						{{ PersonTypeItem.PersonTypeDesc }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>

		<label>Active:</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="ActiveOptionID" [(ngModel)]="ActiveOptionID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstActiveOption" [ngValue]="o.ID">
				{{ o.Desc }}
			</option>
		</select>
	</div>

	<div class="Buttons">
		<button class="btn btn-primary" [disabled]="IsLoading() == true" (click)="onSearch()">Search</button>
	</div>
</div>

<!--Table to Update-->
<div class="ItemBorder TopMargin">
	<caass-ms-visitee-staff-table [loading]="IsLoading() == true" [lstPerson]="lstStaff"> </caass-ms-visitee-staff-table>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onUpdate()">Update</button>
	<button class="btn btn-warning LeftMargin" (click)="onReset()">Reset</button>
</div>
